import { AiFillPieChart } from 'react-icons/ai';
import Footer from '../../components/Footer/Footer';
import { Header } from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Container, Content } from './styles';
import icon_arrecadacao from '../../assets/icone_arrecadacao.svg';
import icon_blacklist from '../../assets/icone_black_list.svg';
import icon_defasagem from '../../assets/icone_defasagem.svg';
import icon_estraticacao from '../../assets/icone_estratificacao.svg';
import icon_fechamento from '../../assets/icone_fechamento.svg';
import icon_penetracao_de_base from '../../assets/icone_penetracao.svg';
import icon_producao from '../../assets/icone_producao.svg';
import icon_ranking from '../../assets/icone_ranking.svg';
import icon_rolagem from '../../assets/rolagem.svg';
import icon_dashboard from '../../assets/icone_dashboard_supervisao.svg';
import ReportCard from '../../components/ReportCard/ReportCard';

function Report() {
  const reports_fakes = [
    {
      icon: icon_producao,
      title: 'Produção',
      key: 1,
    },
    {
      icon: icon_arrecadacao,
      title: 'Arrecadação Geral',
      key: 2,
    },
    {
      icon: icon_rolagem,
      title: 'Rolagem',
      key: 3,
    },
    {
      icon: icon_fechamento,
      title: 'Fechamento comissionamento',
      key: 4,
    },
    {
      icon: icon_estraticacao,
      title: 'Estratificação de Base',
      key: 5,
    },
    {
      icon: icon_blacklist,
      title: 'Blacklist',
      key: 6,
    },
    {
      icon: icon_penetracao_de_base,
      title: 'Penetração de base',
      key: 7,
    },
    {
      icon: icon_defasagem,
      title: 'Defasagem',
      key: 8,
    },
    {
      icon: icon_ranking,
      title: 'Ranking Operação',
      key: 9,
    },
    {
      icon: icon_dashboard,
      title: 'Dashboard de Supervisão',
      key: 10,
    },
  ];

  return (
    <Container>
      <Sidebar />
      <Header
        title="Relatórios"
        icon={<AiFillPieChart color="#A6A6A6" size="32px" />}
      />
      <Content>
        {reports_fakes.map((rep) => (
          <ReportCard key={rep.key} icon={rep.icon} title={rep.title} />
        ))}
      </Content>
      <Footer />
    </Container>
  );
}

export default Report;
